import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

const state = {
  user: null,
  spaceUser: null,
  previousStatus: null,
  position: null,
  config: null,
  configSilenceNotification: null,
  isKiller: false,
  isOnline: false,
};

export type State = typeof state;

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
